export default __webpack_public_path__ + "static/media/bg-pig-cuts.1ba839ef.svg";